import {
  Component,
  OnInit,
  ViewChild,
  HostBinding,
  Input,
  Inject,
  ViewContainerRef,
  OnDestroy
} from '@angular/core';
import { Subject } from 'rxjs';
import { SidePanelService } from '../side-panel.service';
import { WINDOW } from '../../../_services/window.service';

@Component({
  selector: 'app-off-canvas',
  templateUrl: './off-canvas.component.html',
  styleUrls: ['./off-canvas.component.scss']
})
export class OffCanvasComponent implements OnInit, OnDestroy {

  private openedSubject = new Subject();
  opened$ = this.openedSubject.asObservable();

  private closeClickSubject = new Subject();
  closing$ = this.closeClickSubject.asObservable();

  private closedSubject = new Subject();
  closed$ = this.closedSubject.asObservable();

  @Input() from = 'right';

  isActive = false;

  @ViewChild('canvasContent', { read: ViewContainerRef, static: true })
  canvasContent: ViewContainerRef;

  @HostBinding('class.big-canvas') bigCanvas = false;

  public sidePanelService: SidePanelService;

  constructor(@Inject(WINDOW) private window: Window) { }

  ngOnInit() {
    if (this.isFirstPanel) {
      this.window.document.body.classList.add('overflow-y-hidden');
    }
  }

  ngOnDestroy() {
    if (this.isFirstPanel) {
      this.window.document.body.classList.remove('overflow-y-hidden');
    }
  }

  open() {
    this.isActive = true;
    setTimeout(() => {
      this.openedSubject.next(true);
    }, 300);
  }

  close(returnData: any = null) {
    this.isActive = false;
    this.closeClickSubject.next(returnData);
    setTimeout(() => {
      this.closedSubject.next(returnData);
    }, 600);
  }

  get marginMultiplier(): number {
    return (
      this.sidePanelService.openPanelsCount() -
      this.sidePanelService.panelIndex(this) -
      1
    );
  }

  get isFirstPanel(): boolean {
    return this.sidePanelService.panelIndex(this) === 0;
  }
}
